import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Gift, Quote } from 'lucide-react';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/3Gaq57BKCUtTjyUKZsJ5YX/Bono_1.png',
  scale: 1.45,
  label: 'Bono #1',
  title: 'Reset 50+: De Agotada a Encendida en 72 Horas',
  description: 'Tu secuencia clara para los primeros 3 días. Para que no te quedes paralizada sin saber por dónde empezar.',
  quote: 'El primer paso no tiene que ser perfecto. Solo tiene que existir.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/xA4XtyjAKJK63Jo8zG4njz/Bono_2..png',
  scale: 1.2,
  label: 'Bono #2',
  title: 'SOS Hormonal: Tu Menú Anticrisis en 5 Minutos',
  description: 'Comidas anticrisis listas en 5 minutos para los días difíciles, cuando menos energía tienes.',
  quote: 'En los días difíciles no necesitas más fuerza de voluntad. Necesitas un plan más simple.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/4daWHgzJb95gMad7kD3S9D/Bono_3.png',
  scale: 1,
  label: 'Bono #3',
  title: 'Ritual Matutino: 5 Minutos que Reactivan Tu Vitalidad 50+',
  description: 'Una secuencia matutina de 5 minutos para empezar cada mañana con energía e intención.',
  quote: 'No necesitas más tiempo en la mañana. Necesitas usarlo mejor.'
}];
export const BonusSection = () => {
  return <Section bg="bg-gold/10" data-id="element-41">
      <FadeIn data-id="element-42">
        <div className="max-w-3xl mx-auto text-center mb-14" data-id="element-43">
          <span className="inline-flex items-center gap-2 text-gold font-bold tracking-wider uppercase text-sm mb-4" data-id="element-44">
            <Gift className="w-4 h-4" data-id="element-45" />
            Solo Por Hoy
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-6 leading-tight whitespace-nowrap" data-id="element-46">
            Los 3 Bonos{' '}
            <span className="text-gold italic font-normal" data-id="element-47">Gratis Hoy</span>
          </h2>
          <p className="text-lg text-brown-light leading-relaxed" data-id="element-48">
            Cuando te unes hoy, recibes tres recursos adicionales, diseñados
            específicamente para mujeres de 50+, completamente gratis.
          </p>
          <p className="text-sm text-brown-light/70 italic mt-4" data-id="element-49">
            Valor total combinado: <span className="line-through" data-id="element-50">$51 USD</span>
            . Tuyos hoy sin costo extra.
          </p>
        </div>
      </FadeIn>

      <StaggerContainer className="space-y-12 max-w-5xl mx-auto" data-id="element-51">
        {bonuses.map((bonus, i) => <StaggerItem key={i} data-id="element-52">
            <div className={`bg-white rounded-3xl shadow-md overflow-hidden border border-cream-dark grid md:grid-cols-5 gap-0 ${i % 2 === 1 ? 'md:[&>div:first-child]:order-2' : ''}`} data-id="element-53">
              {/* Image */}
              <div className="md:col-span-2 bg-cream-light flex items-center justify-center p-4 md:p-6" data-id="element-54">
                <div className="w-full aspect-[16/9] rounded-xl shadow-lg overflow-hidden bg-cream-light" data-id="element-55">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-56" />
                </div>
              </div>

              {/* Content */}
              <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center" data-id="element-57">
                <div className="flex items-center gap-3 mb-3 flex-wrap" data-id="element-58">
                  <span className="inline-block bg-coral text-white text-xs font-bold tracking-wider uppercase px-3 py-1 rounded-full" data-id="element-59">
                    {bonus.label}
                  </span>
                  <span className="inline-block bg-sage-light text-sage text-xs font-bold px-3 py-1 rounded-full" data-id="element-60">
                    Valorado en $17 · Gratis hoy
                  </span>
                </div>

                <h3 className="text-xl md:text-2xl font-bold mb-4 text-brown leading-tight" data-id="element-61">
                  {bonus.title}
                </h3>

                <p className="text-brown-light leading-relaxed mb-6" data-id="element-62">
                  {bonus.description}
                </p>

                <div className="bg-cream-light border-l-4 border-gold rounded-r-xl p-4 flex items-start gap-3" data-id="element-63">
                  <Quote className="w-5 h-5 text-gold shrink-0 mt-1" data-id="element-64" />
                  <p className="italic text-brown text-sm leading-relaxed" data-id="element-65">
                    {bonus.quote}
                  </p>
                </div>
              </div>
            </div>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
};